module.exports = __webpack_public_path__ + "static/media/188.aeeb0663.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/188.jpg
// module id = 951
// module chunks = 0